import React, { useState } from "react";
import Checkbox from "../designSystem/Checkbox";
import FormInput from "../designSystem/FormInput";
import { Link } from "react-router-dom";
import SecondaryButton from "../designSystem/buttons/SecondaryButton";

const ContactUsComponent = () => {
  const [form, setForm] = useState({
    name: "",
    number: "",
    email: "",
    message: "",
    consent: false,
  });
  const [errors, setErrors] = useState({});
  const [submitStatus, setSubmitStatus] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = ({ target }) => {
    const { name, value, type, checked } = target;

    setForm((previousForm) => ({
      ...previousForm,
      [name]: type === "checkbox" ? checked : value,
    }));
    setErrors((previousErrors) => ({ ...previousErrors, [name]: "" }));
    setSubmitStatus("");
  };

  const validate = () => {
    const nextErrors = {};

    if (!form.name.trim()) nextErrors.name = "Name is required";
    if (!form.number.trim()) nextErrors.number = "Number is required";
    if (!form.email.trim()) nextErrors.email = "Email is required";
    if (!form.message.trim()) nextErrors.message = "Message is required";
    if (!form.consent) {
      nextErrors.consent = "Please confirm you have read the privacy policy";
    }

    setErrors(nextErrors);
    return Object.keys(nextErrors).length === 0;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!validate()) return;

    setIsSubmitting(true);
    setSubmitStatus("");

    try {
      const response = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/send-adviser-contact-confirmation`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            name: form.name.trim(),
            number: form.number.trim(),
            email: form.email.trim(),
            message: form.message.trim(),
            to: (process.env.REACT_APP_ADVISER_EMAIL || "").trim(),
          }),
        },
      );

      if (!response.ok) throw new Error("Contact form request failed");

      setForm({
        name: "",
        number: "",
        email: "",
        message: "",
        consent: false,
      });
      setErrors({});
      setSubmitStatus("Thanks, your message has been sent successfully.");
    } catch (error) {
      setSubmitStatus(
        "Sorry, your message could not be sent. Please try again later.",
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact-us" className="background-container bg-gray-3">
      <div className="content-container column gap-l  py-xxl px-xxxl">
        {/* <div className="column gap-s">
        <div className="content-semibold primary uppercase align-left">
          contact
        </div>
        </div>
        <iframe
          className="contact-map"
          title="Map showing TAG Mortgages, 7 Arrow Court, Alcester, B49 6PU"
          src="https://www.google.com/maps?q=7%20Arrow%20Court%2C%20Alcester%2C%20B49%206PU&output=embed"
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          allowFullScreen
        /> */}
      
          <h2 className="h4 primary uppercase">Get in Touch</h2>
          <form className="column gap-xl" onSubmit={handleSubmit} noValidate>
            <div className="column gap-m">
              <div className="column gap-xs">
                <FormInput
                  id="contact-name"
                  title="Name*"
                  name="name"
                  value={form.name}
                  onChange={handleChange}
                  autoComplete="name"
                  aria-invalid={Boolean(errors.name)}
                  aria-describedby={
                    errors.name ? "contact-name-error" : undefined
                  }
                />
                {errors.name && (
                  <span id="contact-name-error" className="body2 text-error">
                    {errors.name}
                  </span>
                )}
              </div>{" "}
              <div className="column gap-xs">
                <FormInput
                  id="contact-email"
                  title="Email*"
                  name="email"
                  type="email"
                  value={form.email}
                  onChange={handleChange}
                  autoComplete="email"
                  aria-invalid={Boolean(errors.email)}
                  aria-describedby={
                    errors.email ? "contact-email-error" : undefined
                  }
                />
                {errors.email && (
                  <span id="contact-email-error" className="body2 text-error">
                    {errors.email}
                  </span>
                )}
              </div>
              <div className="column gap-xs">
                <FormInput
                  id="contact-number"
                  title="Phone*"
                  name="number"
                  type="tel"
                  value={form.number}
                  onChange={handleChange}
                  autoComplete="tel"
                  aria-invalid={Boolean(errors.number)}
                  aria-describedby={
                    errors.number ? "contact-number-error" : undefined
                  }
                />
                {errors.number && (
                  <span id="contact-number-error" className="body2 text-error">
                    {errors.number}
                  </span>
                )}
              </div>
              <div className="column gap-xs">
                <FormInput
                  id="contact-message"
                  title="Message*"
                  multiline
                  name="message"
                  value={form.message}
                  onChange={handleChange}
                  rows={8}
                  aria-invalid={Boolean(errors.message)}
                  aria-describedby={
                    errors.message ? "contact-message-error" : undefined
                  }
                />
                {errors.message && (
                  <span id="contact-message-error" className="body2 text-error">
                    {errors.message}
                  </span>
                )}
              </div>
            </div>
            <Checkbox
              id="contact-consent"
              name="consent"
              checked={form.consent}
              onChange={handleChange}
              error={errors.consent}
            >
              *I confirm I have read the{" "}
              <Link className="text-primary-1" to="/privacy-policy">
                Privacy Policy
              </Link>
              .
            </Checkbox>
            {/* {errors.consent && (
              <span className="body2 text-error">{errors.consent}</span>
            )} */}
            <SecondaryButton
              type="submit"
              text={isSubmitting ? "SENDING..." : "SUBMIT"}
              disabled={isSubmitting}
              onClick={handleSubmit}
            />
            {submitStatus && (
              <div
                className={`body2 ${
                  submitStatus.startsWith("Thanks")
                    ? "text-success"
                    : "text-error"
                }`}
                role="status"
              >
                {submitStatus}
              </div>
            )}
          </form>
    
      </div>
    </section>
  );
};

export default ContactUsComponent;
